import SvgIcon, { SvgIconProps } from "./SvgIcon";

const DeerIcon: React.FC<SvgIconProps> = ({ variant, ...props }) => {
  return (
    <SvgIcon {...props}>
      {variant == "outlined" ? (
        <>
          <g clipPath="url(#clip0_2736_53)">
            <path
              d="M3 3C3 5 4 6 7 6C9 6 10 7 10 9"
              stroke={props.stroke || "black"}
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
            <path
              d="M21 3C21 5 20 6 17 6C15 6 14 6.333 14 9"
              stroke={props.stroke || "black"}
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
            />

            <path
              d="M15.185 15.889L15.28 15.709C15.6985 16.3086 15.9447 17.0115 15.9917 17.7413C16.0387 18.471 15.8848 19.1997 15.5467 19.8481C15.2085 20.4965 14.6991 21.0397 14.0738 21.4189C13.4485 21.798 12.7313 21.9985 12 21.9985C11.2687 21.9985 10.5515 21.798 9.92617 21.4189C9.30087 21.0397 8.79146 20.4965 8.45333 19.8481C8.11519 19.1997 7.96126 18.471 8.00828 17.7413C8.05529 17.0115 8.30146 16.3086 8.72 15.709"
              stroke={props.stroke || "black"}
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
            <path
              d="M12 18C11 18 8 15 8 12C8 10 9.333 9 12 9C14.667 9 16 10 16 12C16 15 13 18 12 18Z"
              stroke={props.stroke || "black"}
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
            <path
              d="M17 3C17 4.333 16.667 5.333 16 6"
              stroke={props.stroke || "black"}
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
            <path
              d="M7 3C7 4.333 7.333 5.333 8 6"
              stroke={props.stroke || "black"}
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
            <path
              d="M7 6C4.333 6.667 2.667 7.667 2 9"
              stroke={props.stroke || "black"}
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
            <path
              d="M17 6C19.667 6.667 21.333 7.667 22 9"
              stroke={props.stroke || "black"}
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
            <path
              d="M8.5 10L7 9"
              stroke={props.stroke || "black"}
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
            <path
              d="M15.5 10L17 9"
              stroke={props.stroke || "black"}
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
            <path
              d="M12 15H12.01"
              stroke={props.stroke || "black"}
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
          </g>
        </>
      ) : (
        <>
          <g clipPath="url(#clip0_2807_143)">
            <path
              d="M3 3C3 5 4 6 7 6C9 6 10 7 10 9"
              stroke={props.stroke || "black"}
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
            <path
              d="M21 3C21 5 20 6 17 6C15 6 14 6.333 14 9"
              stroke={props.stroke || "black"}
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
            />

            <path
              d="M15.185 15.889L15.28 15.709C15.6985 16.3086 15.9447 17.0115 15.9917 17.7413C16.0387 18.471 15.8848 19.1997 15.5467 19.8481C15.2085 20.4964 14.6991 21.0397 14.0738 21.4189C13.4485 21.798 12.7313 21.9984 12 21.9984C11.2687 21.9984 10.5515 21.798 9.92617 21.4189C9.30087 21.0397 8.79146 20.4964 8.45333 19.8481C8.11519 19.1997 7.96126 18.471 8.00828 17.7413C8.05529 17.0115 8.30146 16.3086 8.72 15.709"
              stroke={props.stroke || "black"}
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
            <path
              d="M17 3C17 4.333 16.667 5.333 16 6"
              stroke={props.stroke || "black"}
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
            <path
              d="M7 3C7 4.333 7.333 5.333 8 6"
              stroke={props.stroke || "black"}
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
            <path
              d="M7 6C4.333 6.667 2.667 7.667 2 9"
              stroke={props.stroke || "black"}
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
            <path
              d="M17 6C19.667 6.667 21.333 7.667 22 9"
              stroke={props.stroke || "black"}
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
            <path
              d="M8.5 10L7 9"
              stroke={props.stroke || "black"}
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
            <path
              d="M15.5 10L17 9"
              stroke={props.stroke || "black"}
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
            <path d="M12 15H12.01H12Z" fill="white" />

            <path
              d="M12 18C11 18 8 15 8 12C8 10 9.333 9 12 9C14.667 9 16 10 16 12C16 15 13 18 12 18Z"
              fill={props.stroke || "black"}
              stroke={props.stroke || "black"}
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
            <path
              d="M12 15H12.01"
              stroke="white"
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
          </g>
          <defs>
            <clipPath id="clip0_2807_143">
              <rect width="24" height="24" fill="white" />
            </clipPath>
          </defs>
        </>
      )}
    </SvgIcon>
  );
};

export default DeerIcon;
